const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const contactRequiredMsg = 'Please provide either a valid email or phone number.';

const borrowerSelfIdentificationSchema = {
  email: [{
    isValid: (input, err, opt, formData) => {
      const emailTrim = typeof (formData && formData.email) === 'string'
        ? formData.email.trim()
        : '';
      const phoneDigits = String((formData && formData.phone) != null ? formData.phone : '').replace(/\D/g, '');

      if (emailTrim) {
        return emailRe.test(emailTrim) ? true : 'Enter a valid email address';
      }
      if (phoneDigits.length === 10) {
        return true;
      }
      if (phoneDigits.length === 0) {
        return contactRequiredMsg;
      }
      return true;
    },
  }],
  phone: [{
    isValid: (input, err, opt, formData) => {
      const emailTrim = typeof (formData && formData.email) === 'string'
        ? formData.email.trim()
        : '';
      const phoneDigits = String((formData && formData.phone) != null ? formData.phone : '').replace(/\D/g, '');

      if (emailTrim) {
        if (phoneDigits.length === 0) {
          return true;
        }
        return phoneDigits.length === 10 ? true : 'Phone number must be 10 digits';
      }
      if (phoneDigits.length === 10) {
        return true;
      }
      if (phoneDigits.length === 0) {
        return contactRequiredMsg;
      }
      return 'Phone number must be 10 digits';
    },
  }],
  ssnLast4: [{
    rule: 'required',
    error: 'Last 4 digits of SSN are required',
  }, {
    isValid: (input) => {
      const digits = String(input != null ? input : '').replace(/\D/g, '');
      if (digits.length !== 4) {
        return 'SSN must be exactly 4 digits';
      }
      return true;
    },
  }],
};

export default borrowerSelfIdentificationSchema;
